(function () {
    'use strict';

    angular
        .module('iMatApp')
        .factory('multipleUploadStorage', multipleUploadStorage);

    multipleUploadStorage.$inject = ['localStorageService'];
    function multipleUploadStorage(localStorageService) {
        var productsKeyName = "Products";

        var service = {
            products: getSetProducts
        };

        return service;

        // -------------------------------------------------------

        function getSetProducts(productInfos) {
            if (angular.isUndefined(productInfos)) {
                return localStorageService.get(productsKeyName);
            }

            localStorageService.set(productsKeyName, productInfos);
            return angular.undefined;
        }
    }
})();